<template lang="pug">
.ChallengeRanking
  .title {{ title }}
  .rankingListHeader
    .position 順位
    .name 名前
    .score 入力速度
    .backSpaceCount バックスペース<br>使用回数
  .rankingList
    .rankingListItem(v-for="item,i in ranking")
      .position {{ i + 1 }}
      .name
        .icon
          km-rank-badge.badge(
            :score="item.score"
          )
        | {{ item.name }}
      .score {{ item.score | toFixed(0) }} 文字/10分
      .backSpaceCount(
        :class="{ perfect: item.backSpaceCount === 0 }"
      ) {{ item.backSpaceCount }}回
</template>

<script>
// import { mapState, mapActions } from 'vuex'
import challengeService from '@/services/ChallengeService'
import RankBadge from '@/components/shared/RankBadge'

export default {
  name: 'km-challenge-ranking',
  components: {
    'km-rank-badge': RankBadge
  },
  props: {
    title: {
      type: String,
      default: 'みんなのランキング'
    },
    ranking: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  filters: {
    toFixed: function(value, length) {
      return value.toFixed(length)
    }
  },
  methods: {},
  mounted() {
    this.rankIndex = challengeService.getRank(this.score)
    this.rankName = challengeService.getRankName(this.rankIndex)
  }
}
</script>

<style lang="scss" scoped>
.ChallengeRanking {
  .title {
    margin: 0 0 20px 0;
    font-size: 2.5rem;
    font-weight: bold;
  }

  .rankingListHeader {
    display: grid;
    grid-template-columns: 100px 1fr 200px 125px;
    grid-auto-rows: 1fr;
    align-items: center;
    top: 0;
    padding: 10px 0;
    width: 100%;
    border-bottom: 3px solid #333;
    color: #333;
    font-size: 14px;
    text-align: left;

    .position {
      margin: 0 10px 0 0;
      text-align: center;
    }

    .name {
      margin: 0 10px 0 0;
      text-align: center;
    }

    .score {
      text-align: center;
    }

    .backSpaceCount {
      text-align: center;
    }
  }

  .rankingList {
    position: relative;
    height: 275px;
    border: 2px solid #333;
    overflow: scroll;
    border-radius: 0 0 10px 10px;

    .rankingListItem {
      display: grid;
      grid-template-columns: 100px 1fr 200px 125px;
      grid-auto-rows: 1fr;
      align-items: center;
      height: 50px;
      border-bottom: 2px solid #333;
      font-size: 24px;

      &:nth-child(even) {
        background: #fff;
      }

      &:nth-child(1) .position {
        color: #333;
        background: gold;
      }

      &:nth-child(2) .position {
        color: #333;
        background: #ddd;
      }

      &:nth-child(3) .position {
        color: #fff;
        background: brown;
      }

      .position {
        margin: 0 10px 0 10px;
        text-align: center;
        border-radius: 5px;
      }

      .name {
        margin: 0 10px 0 0;
        text-align: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        .icon {
          display: inline-block;
          margin: 0 10px 0 0;
          width: 30px;
          height: 30px;
          vertical-align: middle;
        }
      }

      .score {
        text-align: right;
      }

      .backSpaceCount {
        &.perfect {
          color: blue;
        }
      }
    }
  }
}
</style>
